import en from './en';

const config = {
    resources: { en },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'translations',
    keySeparator: '.',
    interpolation: { formatSeparator: false },
    react: { useSuspense: true },
};

export default config;
